export default __webpack_public_path__ + "static/media/OMSC_02.e8568f41.gif";